export const checkIfOrderIsFirst = (ordersCount, index) =>
  !ordersCount && index === 0;
